<sc-recordings-takes
  *ngIf="!selectedTakeID"
  (selectTakeID)="setSelected($event)"
  (closeSidebar)="closeSidebar.emit()"></sc-recordings-takes>

<sc-recordings-take
  *ngIf="selectedTakeID"
  [takeID]="selectedTakeID"
  (selectTakeID)="setSelected($event)"
  (closeSidebar)="closeSidebar.emit()"></sc-recordings-take>
